module.exports = __webpack_public_path__ + "static/media/price.f2c7265d.svg";